'use es6';

import { Map as ImmutableMap } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
export default ((state = ImmutableMap(), action) => {
  const {
    type,
    payload
  } = action;

  if (!payload) {
    return state;
  }

  switch (type) {
    case Actions.USER_ATTRIBUTES_FETCH_SUCCEEDED:
      payload.forEach(attribute => {
        state = state.set(attribute.key, attribute.value);
      });
      return state;

    case Actions.USER_ATTRIBUTES_SYNC_SUCCEEDED:
      return state.set(payload.key, payload.value);

    default:
      return state;
  }
});